import { animate, state, style, transition, trigger } from '@angular/animations';

export const showHide = trigger('showHide', [
  state('void', style({
    transform: 'scaleX(0)',
    height: '0px'
  })),
  transition('void <=> *', animate('120ms'))
]);
